import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CheckoutComponent } from './checkout.component';
import { CheckoutRoutingModule } from './checkout-routing.module';

import { CheckoutMyPlanModule } from './my-plan/my-plan.module';
import { CheckoutMyPackageModule } from './my-package/my-package.module';
import { CheckoutIdentificationModule } from './identification/identification.module';
import { CheckoutPaymentModule } from './payment/payment.module';
import { CheckoutSuccessModule } from './success/success.module';

import { HeaderModule } from '../shared/components/header/header.module';
import { FooterModule } from '../shared/components/footer/footer.module';
import { StepperModule } from '../shared/components/stepper/stepper.module';

import { ProductService } from '../shared/services/product.service';
import { CheckoutMyNewPackageModule } from './my-new-package/my-new-package.module';
import { DiscountModalService } from '../shared/services/discount-modal.service';
import { CheckoutMyHybridPackageModule } from './my-hybrid-package/my-hybrid-package.module';
import { CheckoutTimeoutModule } from './timeout/timeout.module';
import { AlertModule } from "../shared/components/alert/alert.module";

import { ChangePlanModule } from './change-plan/change-plan.module';
import { MonitoreShopWindowComponent } from './shop-windows/monitore-shop-window/monitore-shop-window.component';

@NgModule({
    providers: [
        ProductService,
        DiscountModalService
    ],
    exports: [CheckoutComponent],
    declarations: [
        CheckoutComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        CheckoutRoutingModule,
        CheckoutMyPlanModule,
        CheckoutMyPackageModule,
        CheckoutMyNewPackageModule,
        CheckoutIdentificationModule,
        CheckoutPaymentModule,
        CheckoutSuccessModule,
        CheckoutMyHybridPackageModule,
        CheckoutTimeoutModule,
        HeaderModule,
        FooterModule,
        StepperModule,
        AlertModule,
        ChangePlanModule
    ]
})

export class CheckoutModule { }
